/** Tempo procurando o alvo antes de dizer "Não encontrei este item". */
export const PACIENCIA_PADRAO_MS = 2000;

/** Quadros seguidos com o mesmo retângulo para o alvo contar como parado. */
export const QUADROS_PARA_ASSENTAR = 5;
/** Alvo que nunca para (animação em loop) aparece mesmo assim depois disto. */
export const TETO_PARA_ASSENTAR_MS = 1000;

const seletorDoAlvo = (alvo) => `[data-tour-id="${alvo.replace(/["\\]/g, '\\$&')}"]`;

/**
 * Elemento que carrega o `data-tour-id` pedido, ou null se ainda não montou.
 *
 * O mesmo id pode aparecer mais de uma vez (duas tabelas na tela, uma delas
 * escondida): vale o primeiro que está de fato visível.
 */
export const encontrarAlvo = (alvo) => {
  const candidatos = document.querySelectorAll(seletorDoAlvo(alvo));
  if (candidatos.length === 0) return null;

  for (const el of candidatos) {
    const r = el.getBoundingClientRect();
    if (r.width > 0 && r.height > 0 && el.offsetParent !== null) return el;
  }
  return candidatos[0];
};

/**
 * Transição ou animação finita rodando no alvo ou num ancestral dele: parado
 * não é assentado enquanto o menu lateral ainda abre ou a aba ainda entra.
 * Animação infinita não conta, porque nunca termina; para ela vale o teto.
 */
export const alvoEmMovimento = (el) =>
  document.getAnimations?.().some((animacao) => {
    const efeito = animacao.effect;
    return (
      animacao.playState === 'running' &&
      efeito?.target instanceof Element &&
      efeito.target.contains(el) &&
      efeito.getTiming().iterations !== Infinity
    );
  }) ?? false;

export const medirAlvo = (el) => {
  const r = el.getBoundingClientRect();
  return { top: r.top, left: r.left, width: r.width, height: r.height };
};

export const mesmoRetangulo = (a, b) =>
  a === b ||
  (!!a && !!b && a.top === b.top && a.left === b.left && a.width === b.width && a.height === b.height);
